// @generated by protobuf-ts 2.9.4 with parameter optimize_code_size,long_type_number,generate_dependencies
// @generated from protobuf file "Protos/karma.proto" (package "wuxiaworld.api.v2", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { StringValue } from "../google/protobuf/wrappers";
import { Timestamp } from "../google/protobuf/timestamp";
import { OrderItem } from "./orders";
import { Any } from "../google/protobuf/any";
import { PageInfoResponse } from "./pagination";
import { PageInfoRequest } from "./pagination";
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetMyKarmaTotalsRequest
 */
export interface GetMyKarmaTotalsRequest {
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.KarmaGroup group = 1;
     */
    group: KarmaGroup;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.KarmaTransactionType transactionType = 2;
     */
    transactionType: KarmaTransactionType;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetMyKarmaTotalsResponse
 */
export interface GetMyKarmaTotalsResponse {
    /**
     * @generated from protobuf field: map<int32, int32> totals = 1;
     */
    totals: {
        [key: number]: number;
    };
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetMyKarmaTransactionsRequest
 */
export interface GetMyKarmaTransactionsRequest {
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.KarmaGroup group = 1;
     */
    group: KarmaGroup;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.KarmaTransactionType transactionType = 2;
     */
    transactionType: KarmaTransactionType;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.PageInfoRequest pageInfo = 3;
     */
    pageInfo?: PageInfoRequest;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.GetMyKarmaTransactionsRequest.SortType sortType = 4;
     */
    sortType: GetMyKarmaTransactionsRequest_SortType;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.GetMyKarmaTransactionsRequest.SortDirection sortDirection = 5;
     */
    sortDirection: GetMyKarmaTransactionsRequest_SortDirection;
}
/**
 * @generated from protobuf enum wuxiaworld.api.v2.GetMyKarmaTransactionsRequest.SortType
 */
export enum GetMyKarmaTransactionsRequest_SortType {
    /**
     * @generated from protobuf enum value: RecordedAt = 0;
     */
    RecordedAt = 0
}
/**
 * @generated from protobuf enum wuxiaworld.api.v2.GetMyKarmaTransactionsRequest.SortDirection
 */
export enum GetMyKarmaTransactionsRequest_SortDirection {
    /**
     * @generated from protobuf enum value: ASC = 0;
     */
    ASC = 0,
    /**
     * @generated from protobuf enum value: DESC = 1;
     */
    DESC = 1
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetMyKarmaTransactionsResponse
 */
export interface GetMyKarmaTransactionsResponse {
    /**
     * @generated from protobuf field: repeated wuxiaworld.api.v2.KarmaTransactionItem items = 1;
     */
    items: KarmaTransactionItem[];
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.PageInfoResponse pageInfo = 2;
     */
    pageInfo?: PageInfoResponse;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.KarmaTransactionItem
 */
export interface KarmaTransactionItem {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: google.protobuf.Any unlockedItem = 2;
     */
    unlockedItem?: Any;
    /**
     * @generated from protobuf field: int32 amount = 3;
     */
    amount: number;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.OrderItem order = 4;
     */
    order?: OrderItem;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp recordedAt = 5;
     */
    recordedAt?: Timestamp;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.KarmaGroup karmaGroup = 6;
     */
    karmaGroup: KarmaGroup;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.KarmaTransactionType transactionType = 7;
     */
    transactionType: KarmaTransactionType;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.KarmaTransactionSource transactionSource = 8;
     */
    transactionSource: KarmaTransactionSource;
    /**
     * @generated from protobuf field: google.protobuf.StringValue description = 9;
     */
    description?: StringValue;
}
/**
 * @generated from protobuf enum wuxiaworld.api.v2.KarmaGroup
 */
export enum KarmaGroup {
    /**
     * @generated from protobuf enum value: NoKarmaGroup = 0;
     */
    NoKarmaGroup = 0,
    /**
     * @generated from protobuf enum value: GoldenKarma = 1;
     */
    GoldenKarma = 1,
    /**
     * @generated from protobuf enum value: EarnedKarma = 2;
     */
    EarnedKarma = 2
}
/**
 * @generated from protobuf enum wuxiaworld.api.v2.KarmaTransactionSource
 */
export enum KarmaTransactionSource {
    /**
     * @generated from protobuf enum value: KarmaSourceNone = 0;
     */
    KarmaSourceNone = 0,
    /**
     * @generated from protobuf enum value: KarmaSourceSpend = 1;
     */
    KarmaSourceSpend = 1,
    /**
     * @generated from protobuf enum value: KarmaSourceManual = 2;
     */
    KarmaSourceManual = 2,
    /**
     * @generated from protobuf enum value: KarmaSourcePurchase = 3;
     */
    KarmaSourcePurchase = 3,
    /**
     * @generated from protobuf enum value: KarmaSourceLogin = 4;
     */
    KarmaSourceLogin = 4,
    /**
     * @generated from protobuf enum value: KarmaSourceComment = 5;
     */
    KarmaSourceComment = 5
}
/**
 * @generated from protobuf enum wuxiaworld.api.v2.KarmaTransactionType
 */
export enum KarmaTransactionType {
    /**
     * @generated from protobuf enum value: KarmaTypeNone = 0;
     */
    KarmaTypeNone = 0,
    /**
     * @generated from protobuf enum value: KarmaTypeSpend = 1;
     */
    KarmaTypeSpend = 1,
    /**
     * @generated from protobuf enum value: KarmaTypePurchase = 2;
     */
    KarmaTypePurchase = 2,
    /**
     * @generated from protobuf enum value: KarmaTypeMission = 3;
     */
    KarmaTypeMission = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class GetMyKarmaTotalsRequest$Type extends MessageType<GetMyKarmaTotalsRequest> {
    constructor() {
        super("wuxiaworld.api.v2.GetMyKarmaTotalsRequest", [
            { no: 1, name: "group", kind: "enum", T: () => ["wuxiaworld.api.v2.KarmaGroup", KarmaGroup] },
            { no: 2, name: "transactionType", kind: "enum", T: () => ["wuxiaworld.api.v2.KarmaTransactionType", KarmaTransactionType] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetMyKarmaTotalsRequest
 */
export const GetMyKarmaTotalsRequest = new GetMyKarmaTotalsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMyKarmaTotalsResponse$Type extends MessageType<GetMyKarmaTotalsResponse> {
    constructor() {
        super("wuxiaworld.api.v2.GetMyKarmaTotalsResponse", [
            { no: 1, name: "totals", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "scalar", T: 5 /*ScalarType.INT32*/ } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetMyKarmaTotalsResponse
 */
export const GetMyKarmaTotalsResponse = new GetMyKarmaTotalsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMyKarmaTransactionsRequest$Type extends MessageType<GetMyKarmaTransactionsRequest> {
    constructor() {
        super("wuxiaworld.api.v2.GetMyKarmaTransactionsRequest", [
            { no: 1, name: "group", kind: "enum", T: () => ["wuxiaworld.api.v2.KarmaGroup", KarmaGroup] },
            { no: 2, name: "transactionType", kind: "enum", T: () => ["wuxiaworld.api.v2.KarmaTransactionType", KarmaTransactionType] },
            { no: 3, name: "pageInfo", kind: "message", T: () => PageInfoRequest, options: { "wuxiaworld.api.v2.required": { value: true } } },
            { no: 4, name: "sortType", kind: "enum", T: () => ["wuxiaworld.api.v2.GetMyKarmaTransactionsRequest.SortType", GetMyKarmaTransactionsRequest_SortType] },
            { no: 5, name: "sortDirection", kind: "enum", T: () => ["wuxiaworld.api.v2.GetMyKarmaTransactionsRequest.SortDirection", GetMyKarmaTransactionsRequest_SortDirection] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetMyKarmaTransactionsRequest
 */
export const GetMyKarmaTransactionsRequest = new GetMyKarmaTransactionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMyKarmaTransactionsResponse$Type extends MessageType<GetMyKarmaTransactionsResponse> {
    constructor() {
        super("wuxiaworld.api.v2.GetMyKarmaTransactionsResponse", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => KarmaTransactionItem },
            { no: 2, name: "pageInfo", kind: "message", T: () => PageInfoResponse }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetMyKarmaTransactionsResponse
 */
export const GetMyKarmaTransactionsResponse = new GetMyKarmaTransactionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KarmaTransactionItem$Type extends MessageType<KarmaTransactionItem> {
    constructor() {
        super("wuxiaworld.api.v2.KarmaTransactionItem", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "unlockedItem", kind: "message", T: () => Any },
            { no: 3, name: "amount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "order", kind: "message", T: () => OrderItem },
            { no: 5, name: "recordedAt", kind: "message", T: () => Timestamp },
            { no: 6, name: "karmaGroup", kind: "enum", T: () => ["wuxiaworld.api.v2.KarmaGroup", KarmaGroup] },
            { no: 7, name: "transactionType", kind: "enum", T: () => ["wuxiaworld.api.v2.KarmaTransactionType", KarmaTransactionType] },
            { no: 8, name: "transactionSource", kind: "enum", T: () => ["wuxiaworld.api.v2.KarmaTransactionSource", KarmaTransactionSource] },
            { no: 9, name: "description", kind: "message", T: () => StringValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.KarmaTransactionItem
 */
export const KarmaTransactionItem = new KarmaTransactionItem$Type();
/**
 * @generated ServiceType for protobuf service wuxiaworld.api.v2.Karma
 */
export const Karma = new ServiceType("wuxiaworld.api.v2.Karma", [
    { name: "GetMyKarmaTotals", options: {}, I: GetMyKarmaTotalsRequest, O: GetMyKarmaTotalsResponse },
    { name: "GetMyKarmaTransactions", options: {}, I: GetMyKarmaTransactionsRequest, O: GetMyKarmaTransactionsResponse }
]);
